'use client';

import { Moon, Sun } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useThemeToggle } from '@/hooks/use-theme-toggle';

export function ThemeToggleButton() {
  const { toggleTheme } = useThemeToggle();

  return (
    <Button variant="ghost" onClick={toggleTheme}>
      <Sun
        aria-hidden="true"
        className="h-[1.2rem] w-[1.2rem] scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90"
      />
      <Moon
        aria-hidden="true"
        className="absolute h-[1.2rem] w-[1.2rem] scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0"
      />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
